import PropTypes from 'prop-types';
import React from 'react';
import Classnames from 'classnames';


require('./style.scss');

const Card = props =>
  <div
    className={Classnames('card', props.className, {
      'no-shadow': props.noShadow,
      'no-rounded-border': props.noRoundedBorder,
    })}
    style={{ backgroundColor: props.backgroundColor }}
  >
    {props.children}
  </div>;

Card.Media = props =>
  props.icon || props.media ?
    <div
      className="card-media"
      onClick={props.onClick}
    >
      {props.icon ?
        <div className="card-media-icon">{props.icon}</div> :
        <div className="card-media-image">{props.media}</div>}
    </div> : null;

Card.Content = props =>
  <div className="card-content" {...props}>{props.children}</div>;

Card.Header = props =>
  <div
    className="card-header"
    style={{
      backgroundColor: props.backgroundColor,
      color: props.color,
    }}
  >
    <div className="title-media-wrapper">
      {props.media ? <div className="media">{props.media}</div> : null}
      <div className="title-wrapper" style={{ marginLeft: props.media ? '10px' : null }}>
        {props.title ? <div className="title">{props.title}</div> : null}
        {props.subTitle ? <div className="sub-title">{props.subTitle}</div> : null}
      </div>

      <div className="clearfix" />
    </div>

    {props.children ?
      <div className="meta">
        {props.children}
      </div> : null}
    <div className="actions">{props.actions}</div>
    <div className="clearfix" />
  </div>;

Card.Body = props =>
  <div className="card-body" {...props}>{props.children}</div>;

Card.List = props =>
  <div className="card-list" {...props}>{props.children}</div>;

Card.Footer = props =>
  <div className="card-footer" {...props}>{props.children}</div>;

Card.Divider = () => <hr />;

Card.propTypes = {
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  noRoundedBorder: PropTypes.bool,
  noShadow: PropTypes.bool,
};

Card.Media.propTypes = {
  icon: PropTypes.node,
  media: PropTypes.node,
  onClick: PropTypes.func,
};

Card.Content.propTypes = {
  children: PropTypes.node,
};

Card.Header.propTypes = {
  actions: PropTypes.node,
  backgroundColor: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.string,
  media: PropTypes.node,
  subTitle: PropTypes.node,
  title: PropTypes.node,
};

Card.Body.propTypes = {
  children: PropTypes.node,
};

Card.List.propTypes = {
  children: PropTypes.node,
};

Card.Footer.propTypes = {
  children: PropTypes.node,
};

module.exports = Card;



// WEBPACK FOOTER //
// ./app/components/common/card/Card.jsx